import { useEffect } from 'react'
import { Outlet, Navigate, useParams, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { SUPPORTED_LANGUAGES } from '../lib/constants.js'
import { getBrand } from '../brand/index.js'

export function LanguageRouter() {
  const { lang } = useParams<{ lang: string }>()
  const { i18n } = useTranslation()
  const location = useLocation()

  useEffect(() => {
    if (lang && (SUPPORTED_LANGUAGES as readonly string[]).includes(lang)) {
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang)
      }
      // Persist the choice so routes outside the /:lang/ tree (login,
      // reset-password) can restore it — they never pass through here.
      try { localStorage.setItem('acp-lang', lang) } catch { /* storage unavailable */ }
      // Keep <html lang> and the document title in sync with the URL language.
      document.documentElement.lang = lang
      document.title = `${getBrand().name} — ${i18n.getFixedT(lang, 'common')('documentTagline')}`
    }
  }, [lang, i18n])

  if (!lang || !(SUPPORTED_LANGUAGES as readonly string[]).includes(lang)) {
    // Preserve the rest of the path, replacing the invalid lang segment with 'en'
    const restOfPath = location.pathname.replace(/^\/[^/]*/, '')
    return <Navigate to={`/en${restOfPath}`} replace />
  }

  return <Outlet />
}
